import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Text, Box, Image, Select, Button, Center, Spinner } from "@chakra-ui/react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
  } from '@chakra-ui/react';
import { useDisclosure } from '@chakra-ui/react';
import axios from "axios";
import Tabs from "../../Components/Tabs/Tabs";

const RecentMatches = () => {

    const { isOpen, onOpen, onClose } = useDisclosure();

    const [league, setLeague] = useState("2");
    const [recentMatchData, setRecentMatchData] = useState<any>();
    const [loading, setLoading] = useState(false);

    const currentYear = new Date().getFullYear() - 1;
    const FOOTBALL_KEY = process.env.REACT_APP_FOOTBALL_API_KEY;

    useEffect(() => {
        setLoading(true);
        setLoading(true);
        let URL = `https://v3.football.api-sports.io/fixtures?season=${currentYear}&league=${league}&status=ft&last=14&timezone=Asia/Kolkata`;
        // ! axios config
        let config: any = {
            method: 'get',
            url: URL,
            headers: { 
            'x-rapidapi-host': 'v3.football.api-sports.io', 
            'x-rapidapi-key': `${FOOTBALL_KEY}`
            }
        };

        axios(config)
        .then((result) => {
            // console.log(result);
            setRecentMatchData(result);
            setLoading(false);
        })
        .catch((error)=> {
            console.log(error);
        setLoading(false);
        })
    },[league])

    return(
        <Container maxW={["container.xl","container.sm"]} pb="20">

            <Tabs/>
            
            <Text mt="4" fontSize="2xl" color="#ffffff" fontWeight="bold">
                Recent Matches
            </Text>

            <Box mt="3">
            <Select variant='outline'color="#ffffff" 
            onChange={(e) => setLeague(e.target.value)}>
              <option className="select-options" value="2">UEFA Champions League</option>
              <option className="select-options" value="3">UEFA Europa League</option>
              <option className="select-options" value="39">Premier League</option>
              <option className="select-options" value="78">Bundesliga</option>
              <option className="select-options" value="61">League 1</option>
              <option className="select-options"  value="135">Seria A</option>
              <option className="select-options" value="140">LaLiga Santander</option>
              <option className="select-options" value="324">I-League</option>
              <option className="select-options" value="323">Indian Super League</option>
            </Select>
            </Box>

            {loading ?
            // if loading is true show loading
            <Center>
            <Spinner
            thickness='4px'
            speed='0.65s'
            emptyColor='gray.200'
            color='blue.600'
            size='xl'
            mt={["50%","10%"]}
            />
            </Center>
            :
            // if loading is false show result
            <>
            {loading &&
            <Box display="flex" color="#ffffff" mt="4">
            {recentMatchData &&
            <>
            {recentMatchData.data &&
            <Image
            onClick={onOpen}
            bg="#ffffff"
            boxSize='50px'
            objectFit='cover'
            borderRadius="5px"
            src={recentMatchData.data.response[0].league.logo}
            alt='Dan Abramov'
            />
            }
            </>}

            {recentMatchData &&
            <>
            {recentMatchData.data &&
            <Text fontSize="xl" fontWeight="600" mt="2" ml="3">
            {recentMatchData.data.response[0].league.name}
            </Text>
            }
            </>}
            </Box>}

            {recentMatchData &&
            <>
            {recentMatchData.data.response &&
            <>
            {recentMatchData.data.response.map((data: any) => (
            <Link to={`/match/stats/${data.fixture.id}/${data.goals.home}/${data.goals.away}`}>
            <Box bg="#212121" fontWeight="600" mt="5" color="#ffffff" key={data.fixture.id}>
                <Box display="flex">
                <Text fontSize="xs" ml="2" mt="2">
                    {data.fixture.date.substring(0,10)}
                </Text>
                <Text ml="auto" fontSize="xs" mr="2" mt="2">Full Time</Text>
                </Box>
                <Box display="flex" px="2" pt="2">
                    <Image
                        boxSize='40px'
                        objectFit='cover'
                        src={data.teams.home.logo}
                        alt='Dan Abramov'
                    />
                    <Text mt="2" ml="2">{data.teams.home.name}</Text>
                    <Text ml="auto" mt="2" mr="2">{data.goals.home}</Text>
                </Box>
                <Box display="flex" px="2" pt="2" pb="2">
                    <Image
                    boxSize='40px'
                    objectFit='cover'
                    src={data.teams.away.logo}
                    alt='Dan Abramov'
                    />
                    <Text mt="2" ml="2">{data.teams.away.name}</Text>
                    <Text ml="auto" mt="2" mr="2">{data.goals.away}</Text>
                </Box>
            </Box>
            </Link>
            ))}
            </>}
            </>}
            </>}

            {/* Modal */}
            <Modal size="xs" isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent bg="#1A1C20">
            <ModalHeader color="#ffffff">Select League</ModalHeader>
            <ModalBody color="#ffffff">
            </ModalBody>
            <ModalFooter display="block">
                <Select variant='outline' 
                color="#ffffff" onChange={(e) => setLeague(e.target.value)}>
                <option value="2">UEFA Champions League</option>
                <option value="3">UEFA Europa League</option>
                <option value="39">Premier League</option>
                <option value="78">Bundesliga</option>
                <option value="61">League 1</option>
                <option value="135">Seria A</option>
                <option value="140">LaLiga Santander</option>
                <option value="324">I-League</option>
                <option value="323">Indian Super League</option>
                </Select>
                <Center mt="5">
                <Button onClick={onClose} w="9rem" colorScheme="blue" color="#ffffff">
                Close
                </Button>
                </Center>
            </ModalFooter>
            </ModalContent>
            </Modal>

        </Container>
    );
}

export default RecentMatches;